const config = {
  getUsers: '/users/fetchAllUsers',
  createUser: '/users/create',
  updateUser: '/users/update',
  getUser: '/users',
  getUsersMetrics: '/users/userMetrics',
  getInvoicesMetrics: '/invoices/invoiceMetrics',
  getInvoices: '/invoices/fetchAllInvoices',
  getEnquiries: '/enquiries/search',
  getEnquiryById: '/enquiries',
  updateEnquiry: '/enquiries',
  uploadEnquiry: '/enquiries/upload/sync',
  getInvoiceData: '/invoiceSummaries',
  updateInvoiceSummaries: '/invoiceSummaries/update',
  uploadProfilePicture: '/users/updateProfileIcon',
  fetchLoggedInUser: '/users/profile',
  getCountries: '/countries',
  searchAirports: '/airports/search',
  searchSeaports: '/sea-ports/search',
  getServiceTypes: '/properties/type/SERVICE_TYPE',
  getServiceModes: '/properties/type/SERVICE_MODE',
  getEnquiryStatuses: '/properties/type/ENQUIRY_STATUS',
  getTimeZones: '/properties/type/TIME_ZONE',
  getAllUsers: '/users/fetchAllUsers',
  getManagers: '/users/role-users/manager',
  getClients: '/clients',
  createClient: '/clients/create',
  updateClient: '/clients',
  getClient: '/clients',
  importClients: '/clients/import',
  getClientNames: '/clients/names',
  getPESByServiceType: '/enquiries/service-type',
  quoteComparision: '/quote-comparison/',
  getLocalCharges: '/local-charges',
  getLocalChargesGroups: '/local-cargo-charges',
  getLocalChargesGroupById: '/local-cargo-charges',
  getLocalChargesByPort: '/local-cargo-charges/port',
  createLocalChargesGroup: '/local-cargo-charges/create',
  updateLocalChargesGroup: '/local-cargo-charges',
  checkLocalChargesExists: '/local-cargo-charges/exists',
  uploadLocalCharges: '/local-cargo-charges/import',
  deleteLocalCharges: '/local-cargo-charges',
  getRateCards: '/rate-cards/page',
  getRateCardById: '/rate-cards/route',
  getRateCardByGroup: '/rate-cards/day-group',
  updateRateCardByGroup: '/rate-cards/day-group',
  getRateCardRoutes: '/rate-cards',
  getProductTypes: '/properties/type/PRODUCT_TYPE',
  getRouteTypes: '/properties/type/ROUTE_TYPE',
  createRateCard: '/rate-cards',
  updateRateCard: '/rate-cards/route',
  deleteRateCard: '/rate-cards',
  getRateCardByCarrier: '/rate-cards/carrier',
  getCarriers: '/rate-cards/carriers',
  addRoutesToRateCard: '/rate-cards',
  importRateCard: '/rate-cards/import',
  calculateInternalRate: '/rate-cards/calculate-internal-rate',
  updateInternalRate: '/quote-comparison/vendor-rate',
  updateFreightRate: '/quote-comparison/freight-rate',
  updateVendorLocalCharges: '/vendor-local-charges',
  deleteVendorLocalCharge: '/vendor-local-charges',
  createPackageDetail: '/package-details',
  updatePackageDetail: '/package-details',
  deletePackageDetail: '/package-details',
  getPackageDetailsByEnquiry: '/package-details/enquiry',
  getCurrencyRate: '/currency/rate',
  getEnquiryMarkups: '/enquiry-markups/enquiry',
  createEnquiryMarkups: '/enquiry-markups',
  updateEnquiryMarkup: '/enquiry-markups',
  getEnquiryLocalCharges: '/enquiry-local-charges/enquiry',
  syncEnquiryLocalChargesSelection: '/enquiry-local-charges/enquiry',
  getVendorQuotation: '/vendor-local-charges/vendorQuotation',
  createEnquiryLocalCharge: '/enquiry-local-charges',
  deleteEnquiryLocalCharge: '/enquiry-local-charges',
  bulkDeleteEnquiryLocalCharges: '/enquiry-local-charges/bulk',
  invoiceHistory: 'invoice-history/enquiry',
  getCurrencies: 'currencies',
  saveUpdateMarkups: 'enquiry-markups',
  deleteEnquiryMarkup: '/enquiry-markups',
  getLocalChargesById: '/enquiry-local-charges',
  updateEnquiryStatus: '/enquiries',
  deleteServiceType: '/enquiries/service-type-pe',
  initiateMarkup: '/markup/initate',
  updateAddress: '/addresses',
  getNotesByEnquiry: 'enquiry-notes/enquiry',
  updateEnquiryNotes: 'enquiry-notes/enquiry',
  getCarrierCodes: '/airline-awb-codes',
  deleteRouteByGroup: '/rate-cards/day-group',
  deleteInternalRate: '/rate-cards/internal-rate/vendor-quotation',
};

export default config;
